import { Component, Host, h, Prop } from "@stencil/core";
import { ImpersonateUser } from "../f-impersonate-model";
import FImpersonateCustomerListProps from "./f-impersonate-customer-list-model";

@Component({
  tag: "f-impersonate-customer-list",
  styleUrl: "f-impersonate-customer-list.scss",
  shadow: true,
})
export class FlyoutCustomerList {
  @Prop() emptyListLabel: FImpersonateCustomerListProps["emptyListLabel"];
  @Prop()
  expanderButtonHiddenLabel: FImpersonateCustomerListProps["expanderButtonHiddenLabel"] =
    (window as any).translations["bcp-acc"].close;

  @Prop({ mutable: true }) customers: ImpersonateUser[];

  render() {
    return (
      <Host>
        {this.customers?.length > 0 ? (
          <ul class="impersonate__customer-list">
            {this.customers?.map(
              ({
                customerId,
                customerName,
                customerAddress,
                salesAreaDependentCustomerUid,
              }) => (
                <li class="impersonate__customer-list__item">
                  <f-impersonate-customer-list-item
                    customerId={customerId}
                    customerName={customerName}
                    customerAddress={customerAddress}
                    salesAreaDependentCustomerUid={
                      salesAreaDependentCustomerUid
                    }
                  />
                </li>
              )
            )}
          </ul>
        ) : (
          <f-flyout-message
            messageLabel={this.emptyListLabel}
            data-test="flyout-product-list-flyout-message"
          />
        )}
      </Host>
    );
  }
}
